import React from 'react';
import Video from '../Assets/main.mp4';

const TikTokEmbed = () => {
  return (
    <div style={{ width: '600px', height: '600px', overflow: 'hidden' ,marginTop:"-130px",marginBottom:"-150px"}}>
      <video
        style={{
          border:"1px solid red",
          transform: 'scale(.5)', // Zooms in by 1.5x; adjust as needed
          transformOrigin: 'center center', // Zooms from the center
          width: '100%',
          height: '100%',
          objectFit: 'cover', // Ensures video fills the container without stretching
        }}
        loop
        autoPlay
      muted 
      >
        <source src={Video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default TikTokEmbed;